import RenderCards from "../../../utilities/cards/RenderCards";
export default class Tabs {
  constructor() {
    this.tabs = document.querySelectorAll('[role="tab"]');
    this.tabList = document.querySelector('[role="tablist"]');

    if (this.tabList && this.tabs.length) {
      this.attachHandlers();
    }
  }

  attachHandlers() {
    // Add a click event handler to each tab
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.changeTabs);
    });

    // Enable arrow navigation between tabs in the tab list
    let tabFocus = 0;

    this.tabList.addEventListener("keydown", (e) => {
      // Move right
      if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
        this.tabs[tabFocus].setAttribute("tabindex", -1);
        if (e.key === "ArrowRight") {
          tabFocus++;
          // If we're at the end, go to the start
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
          // Move left
        } else if (e.key === "ArrowLeft") {
          tabFocus--;
          // If we're at the start, move to the end
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }

        this.tabs[tabFocus].setAttribute("tabindex", 0);
        this.tabs[tabFocus].focus();
      }
    });
  }

  changeTabs(e) {
    const target = e.target;
    const parent = target.parentNode;
    const grandparent = parent.parentNode;
    const grandgrandparent = grandparent.parentNode;

    // Remove all current selected tabs
    parent
      .querySelectorAll('[aria-selected="true"]')
      .forEach((t) => t.setAttribute("aria-selected", false));

    // Set this tab as selected
    target.setAttribute("aria-selected", true);

    // Hide all tab panels
    grandgrandparent
      .querySelectorAll('[role="tabpanel"]')
      .forEach((p) => p.setAttribute("hidden", true));

    // Show the selected panel
    grandgrandparent.parentNode
      .querySelector(`#${target.getAttribute("aria-controls")}`)
      .removeAttribute("hidden");

    const render = new RenderCards();
    render.hydrate();
  }
}

// eslint-disable-next-line no-unused-vars
var tabs = new Tabs();
